<template>
  <b-modal v-model="isModalActive" :can-cancel="false">
    <div class="form-modal-widget">
      <div class="form-modal-header">
        <h1 v-if="!form.id">ADD NEW BLOG</h1>
        <h1 v-else>UPDATE BLOG</h1>
      </div>

      <div class="form-modal-body">
        <div class="row">
          <b-field label="Title" style="width: 100%">
            <b-input v-model="form.title"></b-input>
          </b-field>
        </div>
        <div class="row">
          <b-field label="Author" style="width: 100%">
            <b-input v-model="form.author"></b-input>
          </b-field>
        </div>
        <b-field label="Image or Video">
          <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false" allowedUploadTypes="all"
            location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL" :uploadurl="$store.state.BASE_URL + 'upload'"
            name="main-image" :value="form.image" @onFileSelected="(file) => {
              form.image = file;
            }
              ">
            <div class="image-upload-widget">Choose Image or Video to upload</div>
          </upload-trigger>
        </b-field>
        <div class="row">
          <!-- <b-field label="Description" style="width: 100%">
            <b-input v-model="form.description" type="textarea"></b-input>
          </b-field> -->
          <VueEditor v-model="form.description"></VueEditor>
        </div>

        <div class="row">
          <b-field label="Visibility" style="width: 100%">
            <b-select v-model="form.visibility" placeholder="Select a visibility" expanded>
              <option v-for="option in visibilities" :value="option.value" :key="option.value">
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <div class="h-spacer"></div>
          <b-field label="Allow Comments" style="width: 100%">
            <b-switch v-model="form.allowComments">
            </b-switch>
          </b-field>
        </div>
      </div>

      <div class="form-modal-footer">
        <b-button :loading="submit_loading" @click="submitForm()" type="is-primary">
          SUBMIT
        </b-button>
        <b-button @click="onCancel" type="is-primary" outlined>CANCEL</b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { VueEditor } from "vue2-editor";
export default {
  components: { VueEditor },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    isModalActive: true,
    dates: {
      start_date: {
        selected_date: new Date(),
        min_date: new Date(),
        showWeekNumber: false,
        enableSeconds: false,
        hourFormat: undefined, // Browser locale
        locale: undefined, // Browser locale
        firstDayOfWeek: undefined, // 0 - Sundays
      },
      end_date: {
        selected_date: new Date(),
        showWeekNumber: false,
        enableSeconds: false,
        hourFormat: undefined, // Browser locale
        locale: undefined, // Browser locale
        firstDayOfWeek: undefined, // 0 - Sunday
      },
    },
    visibilities: [
      {
        value: "public",
        name: "Public",
      },
      {
        value: "unlisted",
        name: "Unlisted",
      },
    ],
    form: {
      id: null,
      title: '',
      description: '',
      image: '',
      visibility: 'unlisted',
      allowComments: null,
      created_at: '',
      updated_at: '',
      author: ''
    },
    submit_loading: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    if (vm.value) {
      vm.setFormFields();
    } else {
      vm.resetFormFields();
    }
  },
  beforeDestroy() {
    let vm = this;
  },
  methods: {
    setFormFields() {
      let vm = this;
      vm.form.id = vm.value.id;
      vm.form.title = vm.value.title;
      vm.form.description = vm.value.content;
      vm.form.image = vm.value.image;
      vm.form.visibility = vm.value.status;
      vm.form.allowComments = vm.value.commentsEnabled == 1 ? true : false
      vm.form.author = vm.value.author
    },
    resetFormFields() {
      let vm = this;
      vm.form = {
        id: null,
        title: '',
        description: '',
        image: '',
        visibility: 'unlisted',
        allowComments: true,
        created_at: '',
        updated_at: '',
        author: ''
      }
    },
    submitForm() {
      let vm = this;
      // Start validate
      const rules = {
        title: {
          run: (value) => {
            if (!value) {
              return "Title is required";
            }
            return false;
          },
        },
        visibility: {
          run: (value) => {
            if (!value) {
              return "Visibility is required";
            }
            return false;
          },
        },
        author: {
          run: (value) => {
            if (!value) {
              return 'Author is required';
            }
            return false;
          },
        }
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.submit_loading = true;
        let obj = {
          title: vm.form.title,
          author: vm.form.author,
          content: vm.form.description,
          image: vm.form.image,
          commentsEnabled: vm.form.allowComments,
          status: vm.form.visibility,
          id: vm.form.id
        }
        if (!vm.form.id) {
          vm.$store
            .dispatch("BLOGS_ADD_NEW", obj)
            .then((response) => {
              vm.submit_loading = false;
              vm.$emit("success", response.data.return);
              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.submit_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: response.data.message,
              });
            });
        } else {
          vm.$store
            .dispatch("BLOGS_UPDATE", obj)
            .then((response) => {
              vm.submit_loading = false;
              vm.$emit("success", response.data.return);
              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.submit_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: response.data.message,
              });
            });
        }
      }
    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.form-modal-widget {
  width: 600px;
  background: #fff;
  margin: 20px auto;
  border-radius: 5px;

  .form-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;
  }

  .form-modal-body {
    padding: 10px 20px;
    min-height: 200px;
    padding-bottom: 30px;

    .row {
      .quillWrapper {
        margin-bottom: 20px;
        display: flex;
        flex-direction: column;
        height: fit-content;
        width: 100%;
      }
    }
  }

  .form-modal-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 0px 20px;
  }
}
</style>
    